import { chain } from 'lodash';

export default {
  activePromptLevels: (state) => chain(state.promptLevelTemplates)
    .omitBy({ isDeleted: true })
    .map((promptLevelTemplate) => ({
      ...promptLevelTemplate,
      promptLevels: chain(promptLevelTemplate)
        .get('promptLevels')
        .reject({ isDeleted: true })
        .value(),
    }))
    .value(),
};
